import { GoalPlan } from '../client/generated/graphql';

export const marks = ["work", "business-center", "repeat", "wb-sunny", "weekend"];

export const markNames = ["Workdays Only", "Workdays with Extra Effort", "Consistent Daily Effort", "Weekend Boost", "Weekend Only"];

export const mapTargetPlanToNumber = (plan: GoalPlan | null | undefined): number => {
  switch (plan) {
    case GoalPlan.WorkdaysOnly:
      return 1;
    case GoalPlan.WorkdaysWithExtraEffort:
      return 2;
    case GoalPlan.ConsistentDailyEffort:
      return 3;
    case GoalPlan.WeekendBoost:
      return 4;
    case GoalPlan.WeekendOnly:
      return 5;
    default:
      return 3;
  }
}; 